<template>
	<div class="c-radio" :class="[{'z-chk': checkState}, `s-${skin}`]" @click="checkHandle(true)">
		<div></div>
		<span v-if="$slots.default"><slot></slot></span>
	</div>
</template>

<script>
	export default {
		name: 'cRadio',
		
		props: {
			checked: Boolean,
			
			value: [Number, String],
			
			skin: String
		},

		data() {
			return {
				checkState: !!this.checked
			};
		},

		watch: {
			checked(val) {
				this.checkState = !!val;
			},
			
			checkState(val) {
				this.$emit('change', val);
				
				if (val && this.$parent.$options.name == 'cRadioGroup') {
					this.$parent.checkHandle(this.value);
				}
			}
		},

		methods: {
			checkHandle(state) {
				this.checkState = state;
				this.$emit('click', state);
			}
		}
	};
</script>

<style lang="stylus" scoped>
	.c-radio {
		display: inline-block;
		
		&:not(.s-tab) {
			height: .4rem;
			overflow: hidden;
			cursor: pointer;
			
			&:hover {
				div {
					border-color: #bbb;
				}
			}

			&.z-chk {
				div {
					border-color: #000;
					
					&:after {
						width: 9px;
						height: 9px;
					}
				}
				
				span {
					font-weight: bold;
				}
			}

			div {
				float: left;
				position: relative;
				width: .36rem;
				height: .36rem;
				border: 1px solid #ddd;
				border-radius: 100%;
				background: #fff;
				transition: all .1s ease;
				
				&:after {
					content: '';
					position: absolute;
					left: 50%;
					top: 50%;
					width: 0;
					height: 0;
					border-radius: 100%;
					background: #000;
					transform: translate(-50%,-50%);
					transition: all .1s ease;
				}
			}
			
			span {
				float: left;
				margin-left: .1rem;
				line-height: .4rem;
				font-size: .28rem;
			}
		}
		
		&.s-tab {
			position: relative;
			box-sizing: border-box;
			width: 4rem;
			height: .8rem;
			border: .02rem solid #ddd;
			padding: 0 26px;
			margin-right: 3rem !important;
			line-height: .8rem;
			font-size: .3rem;
			text-align: center;
			color: #444;
			cursor: pointer;
			
			&.z-chk,
			&:hover {
				border-color: #1492FF;
				color: #1492FF;
			}
			
			&.z-chk:after {
				content: '';
				position: absolute;
				right: 0;
				bottom 0;
				width: .5rem;
				height: .5rem;
				background-image: url('~@/assets/image/z_crt.png');
				background-size: 100%;
			}
		}
	}
</style>
